const config = {
    user: "oscarrc",
    repo: "oscarrc.github.io"
}

export default config;